function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShelteredWhite({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "-4 -4 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M8.813 7.344c.719 0 1.313-.625 1.313-1.344s-.594-1.344-1.313-1.344H6.657v2.688h2.156zM8.656 2c2.219 0 4 1.781 4 4s-1.781 4-4 4h-2v4H4V2h4.656z",
    style: {
      fill: "#fff",
      fillOpacity: 1,
      stroke: "none"
    },
    transform: "matrix(.9 0 0 .9 .9 2.7)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2 3 6-2 6 2",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeWidth: 2
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShelteredWhite);
export default __webpack_public_path__ + "static/media/sheltered-white.ec4ec830567f4dc71f8198e6411c08a5.svg";
export { ForwardRef as ReactComponent };